import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'antd';
import moment from 'moment';
import { getWallet, getExchange, getExchangeBilling } from '../../common/fetch';
import Wrapper from './style';
import { PC_MONITOR, EXCHANGE_CARD_ICON_BLACK, TEXT_VIDEO_BACKGROUND } from '../../config/media';
import {
	// TABLE_WALLET_COLUMN,
	// TABLE_BILLING_COLUMN
} from '../../config/constants';
// import ExchangeListBar from '../../components/ExchangeListBar';
import { generateFiles } from '../../common/utils';
import { BigPlayButton, ControlBar, Player, Shortcut } from 'video-react';

class Home extends Component {
	state = {
		wallets: [],
		plugins: [],
		billing: [],
		opacityProp:"0"
	};

	componentDidMount() {
		if (this.props.exchange
			&& this.props.exchange.length
		) {
			if (this.props.exchange[0].is_completed) {
				this.props.history.push('/dashboard');
			} else {
				this.props.history.push(`/exchange/setup?id=${this.props.exchange[0].id}`);
			}
		} else {
			this.getData();
			// this.getWallet();
			this.getBilling();
		}
		setTimeout(() => {
			this.setState({ opacityProp:"1" })
		}, 3000);
	}

	componentDidUpdate(prevProps, prevState) {
		if (JSON.stringify(this.props.exchange) !== JSON.stringify(prevProps.exchange)
			&& this.props.exchange.length
		) {
			if (this.props.exchange[0].is_completed) {
				this.props.history.push('/dashboard');
			} else {
				this.props.history.push(`/exchange/setup?id=${this.props.exchange[0].id}`);
			}
		}
	}

	getData = async () => {
		const { exchangeAction, setupActions } = this.props;
		try {
			const res = await getExchange();
			const exchange = res.data.data.sort((a, b) => {
				const ad = new Date(a.updated_at);
				const bd = new Date(a.updated_at);
				if (Math.floor(ad - bd) >= 0) {
					return a - b;
				} else {
					return b - a;
				}
			});

			const setupExchange = res.data.data;
			if (setupExchange.length !== 0) {
				setupActions.updateBiz({
					...setupExchange[0].info.biz,
					id: setupExchange[0].id,
					is_temp: setupExchange[0].info.is_temp,
				});
				setupActions.updateTech({
					...setupExchange[0].info.tech,
					id: setupExchange[0].id,
					type: setupExchange[0].type,
				});
			}

			exchangeAction.readData(exchange);
		} catch (error) {
			console.error(error);
		}
	};

	getWallet = async (page = 1) => {
		try {
			const res = await getWallet(page);
			const wallets = res.data.data
				.sort((a, b) => {
					const AD = new Date(a.created_at);
					const BD = new Date(b.created_at);
					return AD >= BD ? -1 : 1;
				})
				.slice(0, 3);
			this.setState({ wallets });
		} catch (error) {
			console.error(error.response);
		}
	};

	getBilling = async (page = 1) => {
		try {
			const res = await getExchangeBilling(page);
			const billing = res.data.data
				.sort((a, b) => {
					const AD = new Date(a.created_at);
					const BD = new Date(b.created_at);
					return AD >= BD ? -1 : 1;
				})
				.slice(0, 3);
			this.setState({ billing });
		} catch (error) {
			console.error(error.response);
		}
	};

	handleClick = () => {
		this.props.history.push('/exchange/new');
	};

	download = () => {
		const { exchange } = this.props;
		generateFiles(exchange[0]);
	};

	renderPanel = () => {
		const { exchange, history } = this.props;
		if (exchange.length === 0) {
			return (
				<div className="main-panel">
					<div className="main-panel-container" style={{opacity:this.state.opacityProp}}>
						<div className="headerText">Your crypto exchange business starts here.</div>
						{/* <h1>To start your online business simply click the exchange setup button below.</h1> */}
						{/* <img src={PC_MONITOR} alt="pc" className="pc-monitor" /> */}
						{/* <p>
							Start an exchange for free in minutes by clicking create
							exchange below.
							<br />
							Follow the 6 steps and create brand new marketplaces.
						</p> */}
					</div>
				</div>
			);
		}
		const imgIndex = (exchange[0].id % 6) + 1;
		return (
			<div className="main-panel exchange">
				<img src={PC_MONITOR} alt="pc" className="pc-monitor" />
				<div className="exchange-info">
					<h2>My Exchange</h2>
					<img
						src={EXCHANGE_CARD_ICON_BLACK[imgIndex]}
						alt="logo"
						className="exchange-logo"
					/>
					<h3>{exchange[0].name}</h3>
					<div className="url">{exchange[0].url}</div>
				</div>
				<div className="main-panel-container">
					<h3>Important Exchange Details</h3>
					<p>
						<b>Billing status:</b>&nbsp;
						{exchange[0].type === 'Cloud'
							? exchange[0].is_paid
								? (
									<span>Paid (<Link to="/billing">Billing</Link>)</span>
								) : (<Link to="/billing">Payment required</Link>)
							: <span>
								Trial{' '}
								({
									moment(exchange[0].expiry).diff(moment(), 'days') >= 1
										? moment(exchange[0].expiry).diff(moment(), 'days')
										: 0
								} days left){' '}
								(<Link to="/collateral">Collateralize</Link>)
							</span>
						}
						&nbsp;
					</p>
					<p>
						<b>Hosting:</b>{' '}
						{exchange[0].type === 'Cloud'
							? exchange[0].is_paid
								? (<span>{exchange[0].type}</span>)
								: moment(exchange[0].expiry).diff(moment(), 'days') <= 0
									? <span className="expired">Cloud expired <Link to="/billing">(Billing)</Link></span>
									: (<span>Pending cloud (<Link to="/billing">Pending</Link>)</span>)
							: (<span>
								{exchange[0].type}{' '}
								(<Link to="/collateral">Collateralize</Link>){' '}
								(<Link to="/collateral">Get sponsorship</Link>){' '}
							</span>
							)
						}
					</p>
					<div className="exc-btn">
						{/* <Button
							block
							onClick={() => {
								this.download();
								// history.push(`/exchange/preview?id=${exchange[0].id}`);
							}}
						>
							Export Setup File
							Exchange Preview
						</Button> */}
						{!exchange[0].is_completed && (
							<Button
								block
								type="primary"
								onClick={() => {
									history.push(`/exchange/setup?id=${exchange[0].id}`);
								}}
							>
								Review Setup
							</Button>
						)}
					</div>
				</div>
			</div>
		);
	};

	handleEditInvoice = (id) => {
		this.props.editInvoice({ isEdit: true, invoice_id: id });
	};

	render() {
		// const { billing } = this.state;
		const { location, history } = this.props;
		if (location.state && location.state.isLogout) {
			history.go(0);
		}
		const style = {
			// paddingLeft: exchange.length < 1 ? 0 : '45px',
		};
		if (window.innerWidth <= 1200) {
			style.paddingLeft = 0;
		}
		return (
			<Wrapper style={style}>
				<div className="render-container">
				{this.renderPanel()}
				</div>
				<Player autoPlay={true} src={TEXT_VIDEO_BACKGROUND} muted={true} className='player'>
					<BigPlayButton className='big-play-button-hide' />
					<Shortcut clickable={false} dblclickable={false} />
					<ControlBar autoHide={false} disableDefaultControls={true} disableCompletely={true} />
				</Player>
				<div className='footer-container' style={{opacity:this.state.opacityProp}}>
					<div className='footer-button'>
						<Button
							className="exc-btn"
							type="primary"
							onClick={() => {
								history.push('/exchange/new');
							}}
						>
							BEGIN EXCHANGE SETUP
						</Button>
					</div>
					<div className='footer-content'>
						{/* <div className='footer-text'>Are you a developer?</div> */}
						<p className='footer-text'>Try an <a href="https://www.hollaex.com/hollaex-interactive-demo" target="_blank" rel="noopener noreferrer" className='git-anchor'>interactive demo</a></p>
						<div className='footer-text'>View exchange <a href="https://www.hollaex.com/pricing" target="_blank" rel="noopener noreferrer" className='git-anchor'>plans</a></div>
					</div>
				</div>
				{/* <ExchangeListBar /> */}
				{/* <div className="main-card">
					<h3>
						Billing
						<Link to="/billing">More...</Link>
					</h3>

					{billing.length === 0 ? (
						<div className="list-container">
							<div className="empty-card">
								<Icon type="tool" style={{ fontSize: '32px' }} />
								<span>
									You haven't paid for your exchange.
									{'  '}
									<Link to="/billing">Go to billing page.</Link>
								</span>
							</div>
						</div>
					) : (
							<Table
								columns={TABLE_BILLING_COLUMN(exchange[0] || {}, this.handleEditInvoice)}
								dataSource={billing}
								rowKey={(data) => {
									return data.id;
								}}
								pagination={false}
							/>
						)}
				</div> */}
				{/* <div className="main-card">
					<h3>
						Wallet
						<Link to="/wallet">More...</Link>
					</h3>

					{wallets.length === 0 ? (
						<div className="list-container">
							<div className="empty-card">
								<Icon type="dollar" style={{ fontSize: '32px' }} />
								<span>
									You haven't connected a wallet to your exchange.
									{'  '}
									<Link to="/wallet">Go to wallet page.</Link>
								</span>
							</div>
						</div>
					) : (
						<Table
							columns={TABLE_WALLET_COLUMN}
							dataSource={wallets}
							rowKey={(data) => {
								return data.id;
							}}
							pagination={false}
						/>
					)}
				</div>
				<div className="main-card">
					<h3>
						Plugins<Link to="/plugin">More...</Link>
					</h3>
					{plugins.length === 0 ? (
						<div className="list-container">
							<div className="empty-card">
								<Icon type="tool" style={{ fontSize: '32px' }} />
								<span>
									For smooth operations add an exchange plugins.{'  '}
									<Link to="/plugin">Go to plugin page.</Link>
								</span>
							</div>
						</div>
					) : (
						<div className="list-container">
							<div className="empty-card">
								<Icon type="tool" style={{ fontSize: '32px' }} />
								<span>
									For smooth operations add an exchange plugins.{'  '}
									<Link to="/plugin">Go to plugin page.</Link>
								</span>
							</div>
						</div>
					)}
				</div> */}
			</Wrapper>
		);
	}
}

export default Home;
